import { createAuthClient } from "better-auth/react";
import {
  genericOAuthClient,
  magicLinkClient,
} from "better-auth/client/plugins";
import { API_BASE_URL } from "@/lib/api-url";

const authOrigin = API_BASE_URL || window.location.origin;

export const authClient = createAuthClient({
  baseURL: `${authOrigin.replace(/\/+$/, "")}/api/better-auth`,
  fetchOptions: {
    credentials: "include",
  },
  plugins: [magicLinkClient(), genericOAuthClient()],
});

// Export commonly used methods
export const { signIn, signUp, signOut, useSession, getSession } = authClient;

// Type exports
export type Session = typeof authClient.$Infer.Session;
